import { render, staticRenderFns } from "./AreaCode.vue?vue&type=template&id=38bfec37&scoped=true&"
import script from "./AreaCode.vue?vue&type=script&lang=js&"
export * from "./AreaCode.vue?vue&type=script&lang=js&"
import style0 from "./AreaCode.vue?vue&type=style&index=0&id=38bfec37&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bfec37",
  null
  
)

export default component.exports